import { render, staticRenderFns } from "./xtGoodsReportList.vue?vue&type=template&id=10b396fc"
import script from "./xtGoodsReportList.vue?vue&type=script&lang=js"
export * from "./xtGoodsReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports